export const environment = {
    baseURL: "https://tracllo-node-178a480f7a89.herokuapp.com",
    timeout: 200000
};